import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a3c680c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dv-question-title" }
const _hoisted_2 = { style: {"display":"flex"} }
const _hoisted_3 = {
  key: 0,
  class: "dv-title-index"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 1,
  class: "dv-title-score"
}
const _hoisted_6 = {
  class: "scene",
  ref: "sceneRef"
}
const _hoisted_7 = ["height", "width", "src"]
const _hoisted_8 = ["type"]
const _hoisted_9 = ["type"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "imgLoading" }, "加载中", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "加载失败", -1))
const _hoisted_12 = { class: "boardContent" }
const _hoisted_13 = ["dataX", "dataY", "type"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "imgLoading" }, "加载中", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "imgLoading" }, "加载中", -1))
const _hoisted_16 = {
  key: 0,
  class: "question-correct_answer"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "correct_answer-title" }, "正确答案:", -1))
const _hoisted_18 = { class: "correct_answer-content" }
const _hoisted_19 = ["width", "src"]
const _hoisted_20 = {
  key: 1,
  class: "question-analysis"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "analysis-title" }, "解析:", -1))
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = { class: "jigSawMask" }
const _hoisted_24 = { class: "jigSawText" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.props.showQuestionNum)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.questionData.indexInQuestion !== undefined
            ? _ctx.questionData.indexInQuestion + "."
            : "") + _toDisplayString(_ctx.questionData.titleNum > 0 ? _ctx.questionData.titleNum : ""), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          innerHTML: _ctx.questionData.title,
          id: "dvCompile",
          class: "dv-title",
          ref: "questionTitle"
        }, null, 8, _hoisted_4),
        (_ctx.props.showQuestionScore)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, " (" + _toDisplayString(_ctx.questionData.score) + "分) ", 1))
          : _createCommentVNode("", true)
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
        (_ctx.draggingImgData.show)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              height: _ctx.draggingImgData.height,
              width: _ctx.draggingImgData.width,
              class: "maskImg",
              src: _ctx.draggingImgData.url,
              style: _normalizeStyle(_ctx.draggingImgData.style)
            }, null, 12, _hoisted_7))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "optionContent",
          style: _normalizeStyle(_ctx.getBoardStyle(10)),
          type: _ctx.typeMap.option.value
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sceneData.optionsData, (option) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "optionItem",
              key: option.id,
              type: _ctx.typeMap.option.value
            }, [
              _createVNode(_component_el_image, {
                draggable: !_ctx.isPreview,
                type: _ctx.typeMap.option.value,
                dataId: option.id,
                src: option.url
              }, {
                placeholder: _withCtx(() => [
                  _hoisted_10
                ]),
                error: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 2
              }, 1032, ["draggable", "type", "dataId", "src"])
            ], 8, _hoisted_9))
          }), 128))
        ], 12, _hoisted_8),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", {
            ref: "boardRef",
            class: "board",
            style: _normalizeStyle(_ctx.getBoardStyle())
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.boardData, (rowArr, y) => {
              return (_openBlock(), _createElementBlock("div", {
                style: _normalizeStyle(y === 0 && { background: 'none', padding: 0 }),
                class: "boardRow",
                key: `boardRow-${y}`
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rowArr, (item, x) => {
                  return (_openBlock(), _createElementBlock("div", {
                    style: _normalizeStyle(x === 0 && { background: 'none', padding: 0 }),
                    class: "boardItem",
                    key: `boardItem-${x}-${y}`,
                    dataX: x,
                    dataY: y,
                    type: _ctx.typeMap.board.value
                  }, [
                    (item.url)
                      ? (_openBlock(), _createBlock(_component_el_image, {
                          key: 0,
                          draggable: !_ctx.isPreview,
                          style: {"width":"100%","height":"100%"},
                          dataId: item.id,
                          src: item.url,
                          type: _ctx.typeMap.board.value,
                          dataX: x,
                          dataY: y,
                          fit: "fill"
                        }, {
                          placeholder: _withCtx(() => [
                            _hoisted_14
                          ]),
                          error: _withCtx(() => [
                            _hoisted_15
                          ]),
                          _: 2
                        }, 1032, ["draggable", "dataId", "src", "type", "dataX", "dataY"]))
                      : _createCommentVNode("", true)
                  ], 12, _hoisted_13))
                }), 128))
              ], 4))
            }), 128))
          ], 4)
        ])
      ])), [
        [_directive_loading, _ctx.initLoading]
      ]),
      (_ctx.props.disabled)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("img", {
                width: _ctx.getJigsawWidth(),
                src: _ctx.answerImgSrc,
                alt: ""
              }, null, 8, _hoisted_19)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.props.disabled)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", {
              class: "analysis-content",
              innerHTML: _ctx.question?.analysis || ''
            }, null, 8, _hoisted_22)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.jigSawLoading == true)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: "body"
        }, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.jigSawText), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}